var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 6,
    viewBox: "0 0 220 6",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83214e-05 6.00019H0.0967014H220L208.425 2.88017L198.41 2.32918L184.686 3.87376L170.905 2.88017L162.63 3.87376L155.051 2.32933L138.856 2.88017L122.663 3.60242L108.956 1.78718L97.1106 3.11611L92.7693 1.78718L77.7607 4.12288L63.5795 3.60242H50.2862L24.5929 1.20312L9.29891 2.88017L6.83214e-05 6.00019Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderX);
export default __webpack_public_path__ + "static/media/border-x.748a762d7fd8b0743faef108bf3bda79.svg";
export { ForwardRef as ReactComponent };